import { ReduxState } from 'services/types';

export const skuItems = (state: ReduxState) => state.inventory.skuItems;
export const skuItemsData = (state: ReduxState) => skuItems(state).data;
export const skuItemsLoading = (state: ReduxState) => skuItems(state).loading;
export const skuItemsError = (state: ReduxState) => skuItems(state).error;

export const inventoryItems = (state: ReduxState) => state.inventory.inventoryItems;
export const inventoryItemsData = (state: ReduxState) => inventoryItems(state).data;
export const inventoryItemsLoading = (state: ReduxState) => inventoryItems(state).loading;
export const inventoryItemsError = (state: ReduxState) => inventoryItems(state).error;

export const inventoryConfiguration = (state: ReduxState) => state.inventory.configuration;
export const inventoryConfigurationData = (state: ReduxState) => inventoryConfiguration(state).data;
export const inventoryConfigurationLoading = (state: ReduxState) =>
	inventoryConfiguration(state).loading;
export const inventoryConfigurationError = (state: ReduxState) =>
	inventoryConfiguration(state).error;

export const inventoryItemsIds = (state: ReduxState) =>
	inventoryItemsData(state)?.flatMap((i) => i.identifiers);
